import { Button, Dialog, Text } from 'braid-design-system';
import { useId, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import type { FormValues } from '#src/pages/manage/security-breach/SecurityBreach.tsx';

export const ClearForm = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        tone="critical"
        onClick={() => {
          setOpen(true);
        }}
      >
        Clear
      </Button>
      <ClearFormConfirmation open={open} setOpen={setOpen} />
    </>
  );
};

interface ClearFormConfirmationProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const ClearFormConfirmation = ({
  open,
  setOpen,
}: ClearFormConfirmationProps) => {
  const { reset } = useFormContext<FormValues>();

  return (
    <Dialog
      width="xsmall"
      id={useId()}
      title="Clear form"
      open={open}
      onClose={() => setOpen(false)}
    >
      <Text>
        Are you sure you want to clear the form? This will remove all entered
        data.
      </Text>
      <Button
        onClick={() => {
          reset({
            dataType: '',
            usersImpacted: '',
            productsImpacted: [],
            startDate: '',
            seekData: 'No',
            seekCredentials: 'No',
            seekFault: 'No',
            actionTaken: 'No',
            actions: '',
            partnerName: '',
            contactName: '',
            contactEmail: '',
            contactPhone: '',
            contactHours: '',
            extraDetails: '',
            otherProduct: '',
          });
          localStorage.removeItem('securityBreachFormValues');
          setOpen(false);
        }}
        tone="critical"
      >
        Clear form
      </Button>
    </Dialog>
  );
};
